import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import character2 from '../../assets/images/betshop-baccarat/character-2.png';
import character1 from '../../assets/images/betshop-baccarat/character-1.png';
import {
  BET_TYPES_VIEW,
  COLOR_BY_WIN_TYPE,
  ROUND_BET_TYPE_VIEW,
  ROUND_WIN_TYPE_VIEW,
} from '../../enums/betTypesEnum';

export const BetShopWiningType = observer(({ winType, isPairWin }) => {
  const t = useTranslation();

  const WinImgComp = useCallback(() => {
    if (winType === ROUND_BET_TYPE_VIEW.BANKER) {
      return (
        <div className='bb-sign-inside'>
          <img src={character2} alt='' />
        </div>
      );
    }
    if (winType === ROUND_BET_TYPE_VIEW.PLAYER) {
      return (
        <div className='bb-sign-inside'>
          <img src={character1} alt='' />
        </div>
      );
    }
    return null;
  }, [winType]);

  const WinTypeNameComp = useCallback(() => {
    if (winType === ROUND_BET_TYPE_VIEW.BANKER) {
      return (
        <p className='bb-banner-txt'>
          {t('BANKER')} {t('WINS')}
        </p>
      );
    }
    if (winType === ROUND_BET_TYPE_VIEW.PLAYER) {
      return (
        <p className='bb-banner-txt'>
          {t('PLAYER')} {t('WINS')}
        </p>
      );
    }
    return (
      <p className='bb-banner-txt'>
        {t('TIE')} {t('WINS')}
      </p>
    );
  }, [t, winType]);

  return (
    <div className='bb-banner-holder'>
      {/* Add class - red-banner // green-banner // blue-banner - to change color */}
      {/* Add class - red-sign // blue-sign // to change color of sign */}
      <div className={`bb-banner ${COLOR_BY_WIN_TYPE[ROUND_WIN_TYPE_VIEW[winType]]}-banner`}>
        {winType !== BET_TYPES_VIEW.TIE && (
          <div
            className={`bb-sign md ${
              COLOR_BY_WIN_TYPE[ROUND_WIN_TYPE_VIEW[winType]]
            }-sign rotated-${winType === ROUND_BET_TYPE_VIEW.BANKER ? 'r' : 'l'}`}
          >
            <WinImgComp />
          </div>
        )}
        <WinTypeNameComp />
        {isPairWin && <p className='bb-banner-txt'>{t('PAIR')}</p>}
      </div>
    </div>
  );
});
